import { render, staticRenderFns } from "./DocumentTypes.vue?vue&type=template&id=13bdad2e&scoped=true"
import script from "./DocumentTypes.vue?vue&type=script&lang=js"
export * from "./DocumentTypes.vue?vue&type=script&lang=js"
import style0 from "./DocumentTypes.vue?vue&type=style&index=0&id=13bdad2e&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13bdad2e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\a\\1\\s\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('13bdad2e')) {
      api.createRecord('13bdad2e', component.options)
    } else {
      api.reload('13bdad2e', component.options)
    }
    module.hot.accept("./DocumentTypes.vue?vue&type=template&id=13bdad2e&scoped=true", function () {
      api.rerender('13bdad2e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/infra/bidDocumentation/components/DocumentTypes.vue"
export default component.exports